module.exports = __webpack_public_path__ + "assets/img/img224.80489ace.png";